// Shrink a picked/captured photo before uploading — phone photos are often
// 4–12 MB, far more than any use here needs. Returns a JPEG File, or the
// original file if the browser can't decode it (e.g. HEIC outside Safari).
export async function downscaleImage(file, maxSide = 1600, name = 'imagen.jpg') {
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', 0.85));
    return blob ? new File([blob], name, { type: 'image/jpeg' }) : file;
  } catch {
    return file;
  }
}
